/* */ 
"use strict";
var forms_1 = require('./forms');
var directives_1 = require('./directives');
exports.COMMON_DIRECTIVES = [directives_1.CORE_DIRECTIVES, forms_1.FORM_DIRECTIVES];
